import React from 'react';
import DynamicPage from '../components/DynamicPage';

const BlogPage: React.FC = () => {
  return (
    <DynamicPage 
      pageType="blog"
      title=""
      backButtonText="Back to Home"
    />
  );
};

export default BlogPage;
